import React, {Component} from 'react';
import {connect} from 'react-redux';
import { Button, Card, Col, Container, Input, Nav, NavItem, Row,Alert} from "reactstrap";
import { NavLink} from "react-router-dom";
import validator from 'validator';
import axios from "axios";
import {LangValidation} from "./../../lang/en/validation";
import axiosRetry from 'axios-retry';
import {setUser} from "./../../redux/actions/user";
import {API_URL} from "./../../config/Config";
import SaveLoader from "../../components/loader/SaveLoader";

axiosRetry(axios, { retries: 3 });

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeItemPills: '1',
            fields: {
                email:'',
                password: '',
            },
            errors: {},
            hasAlert:false,
            loading:true,
            apiError:"Your Email or Password is wrong"
        };

    }

    handleValidation(callback) {
        let {fields} = this.state;
        let errors = {};
        let formIsValid = true;

        if (validator.isEmpty(fields.email)) {
            formIsValid = false;
            errors["email"] = LangValidation.required;
        }else if (!validator.isEmail(fields.email)) {
            formIsValid = false;
            errors["email"] = LangValidation.email;
        }

        if (validator.isEmpty(fields.password)) {
            formIsValid = false;
            errors["password"] = LangValidation.required;
        }else if (!validator.isLength(fields.password, {min: 6, max: undefined})) {
            formIsValid = false;
            errors["password"] = LangValidation.min;
        }

        this.setState({errors}, () => {
            return callback(formIsValid)
        });

    }

    handleChange(event) {
        let fields = this.state.fields;
        let errors = {};
        let target = event.target;
        fields[target.name] = target.value;

        switch (target.name) {
            case 'password':
                if (validator.isEmpty(fields.password)) {
                    errors["password"] = LangValidation.required;
                }else if (!validator.isLength(fields.password, {min: 6, max: undefined})) {
                    errors["password"] = LangValidation.min;
                }
                break;
            case 'email':
                if (validator.isEmpty(fields.email)) {
                    errors["email"] = LangValidation.required;
                }else if (!validator.isEmail(fields.email)) {
                    errors["email"] = LangValidation.email;
                }
                break;
            default:

        }
        this.setState({
            fields,errors
        });

    }

    async handleRequest() {
        const formData = new FormData();
        const { password, email} = this.state.fields;
        formData.append('password',password);
        formData.append('email',email);
        this.setState({loading: false});
        try {
            let response = await axios.post(`${API_URL}login`,formData);
            if (response.status < 200 || response.status > 300) {
                const error = new Error(response.statusText);
                error.response = response;
               if (error.response === undefined) {
                    console.log(error);
                } else {
                   let data = await error.response.data;
                   let apiErrorText = await data.data;
                   this.setState({apiErrorText});
                }
                this.setState({hasAlert:true});
            }else{
                let user = response.data.data;
                console.log(user);
                this.props.setUser(user);
                // this.props.history.push('/users');
                window.location.replace("/users");
            }
        }catch (e) {
            let apiError = await e.response;

            if (apiError === undefined) {
                console.log(e);
            } else {
                // let statusText = await apiError.statusText;
                // let status = await apiError.status;
                let data = await apiError.data;
                let apiErrorText = await data.data;
                this.setState({apiErrorText});
            }
            this.setState({hasAlert:true});

        }
        console.log("done");
        this.setState({loading: true});
    };

    handleLogin(event) {
        event.preventDefault();
        this.handleValidation((valid) => {
            if (valid) this.handleRequest();
        });
    }

    render() {
        const { password, email} = this.state.fields;
        const {errors} = this.state;


        return (
            <div className="pt-5">
                <Container className="pt-5">
                    <div className="container login-container" >
                        <div className="row">
                            <div className="col-md-6 " style={{float: "none", margin: "0 auto"}}>
                                <Card style={{padding:20}}>

                                    <div className="card-header1 mb-2">
                                        <Nav pills color="secondary" className="nav-justified mt-2">
                                            <NavItem>
                                                <Button color="primary" to="/login" className="btn btn-block btn-green">
                                                    Sign in
                                                </Button>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink to="/register" className="btn btn-link">
                                                    Sign up
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                        <hr/>
                                        <Row>
                                            <Col md="12">
                                                {this.state.hasAlert? <Alert color="danger">{this.state.apiError}</Alert> :""}
                                            </Col>
                                        </Row>
                                        <form className='validate-form'>
                                            <Row>

                                                <Col md="12" sm="12">
                                                    <div className="md-form2 input-group2">

                                                        <Input type="email"
                                                               label="Email"
                                                               icon="envelope"
                                                               className={errors["email"]?"form-control is-invalid":"form-control"}
                                                               autoComplete="off"
                                                               name="email"
                                                               value={email}
                                                               onChange={this.handleChange.bind(this)}/>
                                                        {errors["email"]?<div className="invalid-feedback" >{errors["email"]}</div>:""}

                                                    </div>
                                                    <br/>
                                                    <div className="md-form2 input-group2">

                                                        <Input type="password"
                                                               label="Password"
                                                               icon="key"
                                                               className={errors["password"]?"form-control is-invalid":"form-control"}
                                                               autoComplete="off"
                                                               name="password"
                                                               value={password}
                                                               onChange={this.handleChange.bind(this)}/>
                                                        {errors["password"]?<div className="invalid-feedback" >{errors["password"]}</div>:""}

                                                    </div>

                                                    <div className="text-center mt-5">
                                                        <Button size="lg" block onClick={this.handleLogin.bind(this)} className="mb-4 mt-4 btn-navy">
                                                            <i className="la la-sign-in ml-1"/>Login
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </form>
                                    </div>
                                </Card>
                            </div>
                        </div>
                    </div>
                    {!this.state.loading ? <SaveLoader type='spinningBubbles' color='#fff' height={document.body.clientHeight}/>:""}

                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
};
const mapDispatchToProps = dispatch => {
    return {
        setUser : user => {
            dispatch(setUser(user))
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/auth/Login.js